import React, {useState} from 'react';
import Stack from '@mui/material/Stack';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import {useTheme} from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import {useNavigate, useParams} from 'react-router-dom';
import {useOffSetTop} from 'src/hooks/use-off-set-top';
import {useResponsive} from 'src/hooks/use-responsive';
import {useSnackbar} from 'notistack';
import {bgBlur} from 'src/theme/css';
import {m} from 'framer-motion';
import {useTranslation} from 'react-i18next';
import {alpha} from '@mui/material/styles';

import Logo from 'src/minimal-components/logo/logo';
import SvgColor from 'src/minimal-components/svg-color/svg-color';
import {useSettingsContext} from 'src/minimal-components/settings';

import Searchbar from '../common/searchbar';
import {NAV, HEADER} from '../config-layout';
// import SettingsButton from '../common/settings-button';
import AccountPopover from '../common/account-popover';
// import ContactsPopover from '../common/contacts-popover';
// import LanguagePopover from '../common/language-popover';
// import NotificationsPopover from '../common/notifications-popover';
import {
  Button,
  Divider,
  Grid,
  MenuItem,
  Tooltip,
  Typography
} from '@mui/material';
import {Add, Edit} from '@mui/icons-material';
import {
  BASE_APPLICATION,
  BASE_DATA_GRID_ROW,
  BASE_DEMOGRAPHIC_ID,
  BASE_LEGACY_APP,
  BASE_MENU_ITEM,
  BASE_PROCEDURE_ID,
  BASE_RECORD_ID,
  BASE_ROUTE,
  BASE_ROUTE_MODULE,
  BASE_ROUTE_PAD,
  BASE_ROUTE_SUB_MODULE,
  BASE_ROUTE_WIDGETS,
  BASE_UNIQUE_ID,
  CHILD_TAB_NAME,
  INVOICE_NUMBER,
  IS_FROM_EPIC,
  IS_FROM_ATHENA,
  MODE,
  MOVE_TO_TAB,
  PARAMS_KEY
} from 'src/routes/BaseRoute';
import FormConstants from '@shared/constants/FormConstants';
import {
  getLMSResultsData,
  getPageData,
  getSearchForm,
  getSearchResultsData
} from '@shared/services/service-handlers/PrivateService';
import {getErrorMessage} from '@shared/utils/ErrorUtils';
import SnackBarConfig from '@components/snackbar/SnackbarConfig';
import Box from '@mui/material/Box';
import {varHover} from 'src/minimal-components/animate';
import Iconify from 'src/minimal-components/iconify';
import EncryptUtils from 'src/utils/EncryptUtils';
import {
  PAEncounterContainerDiv,
  EncounterContainerDiv,
  EncounterDiv,
  FilterDataDiv,
  InfoGrid,
  PadButton
} from '@modules/home/common/top-app-bar/TopAppBarStyles';
import AuthUtils from 'src/utils/AuthUtils';
import {useAppContext} from '@context/AppContext';
import HelperUtils from '@shared/utils/HelperUtils';
import {useSelectedCheckBoxContext} from '@context/SelectedCheckBoxContext';
import CustomPopover from 'src/minimal-components/custom-popover/custom-popover';
import {usePopover} from 'src/minimal-components/custom-popover';
import {useBannerDetails} from '@context/BannerContext';
import RedEasyButtonComponent from '@components/redEasyButton';
import {environment} from '@shared/config/environment';
import {RHFSelect} from 'src/minimal-components/hook-form';
import SelectInput from '@components/form/select-input/SelectInput';
import data from '@iconify/icons-solar/money-bag-bold';
import {minWidth} from '@mui/system';

// ----------------------------------------------------------------------

export default function Header(props: any): React.ReactElement {
  const theme = useTheme();
  const {helpResourceLinks, globalSearchConfig} = environment;
  const {
    appState: {applicationName, hospitalId}
  } = useAppContext();
  const {setHospitalData} = useAppContext();
  const {t} = useTranslation();
  const {enqueueSnackbar} = useSnackbar();
  const navigate = useNavigate();
  const popover = usePopover();
  const popoverhelp = usePopover();
  interface LMSUIData {
    module_sql?: {
      sql_data: any;
      order_by?: string;
      sort_by?: string;
    };
  }
  const [lmsUIData, setLMSUIData] = useState<LMSUIData | null>(null);
  const [dropDownData, setDropDownData]: any = useState([]);
  const params: any = useParams();

  const [bannerDetailsData, setBannerDetailsData]: any = useState({});
  const [bannerDetailsUIData, setBannerDetailsUIData]: any = useState([]);
  const getLocaleStorageData = AuthUtils.getSelectedCheckBoxData();
  const getAdditionalLocaleStorageData =
    AuthUtils.getSelectedAdditionalCheckBoxData();
  const {
    onOpenNav,
    module,
    subModule,
    record_id,
    legacyApp,
    banner_details,
    handleAddPadAction,
    applicationId,
    padId,
    renderParentLegacyAppFilter,
    ParentLegacyValue,
    navData,
    onHelpOptionClick
  } = props;
  const {setBannerDetails} = useBannerDetails();
  const [filtersData, setFiltersData] = useState<any>();
  const {SelectedCheckBoxState} = useSelectedCheckBoxContext();
  const [isRestricted, setisRestricted] = useState(false);
  const settings = useSettingsContext();
  const isNavHorizontal = settings.themeLayout === 'horizontal';
  const isNavMini = settings.themeLayout === 'mini';
  const lgUp = useResponsive('up', 'lg');
  const offset = useOffSetTop(HEADER.H_DESKTOP);
  const offsetTop = offset && !isNavHorizontal;

  const recordId = EncryptUtils.getDecryptedData(
    location?.search,
    BASE_RECORD_ID
  );

  const legacy_app = EncryptUtils.getDecryptedData(
    location?.search,
    BASE_LEGACY_APP
  );

  const uniqueId = EncryptUtils.getDecryptedData(
    location?.search,
    BASE_UNIQUE_ID
  );
  const isFromEpic = EncryptUtils.getDecryptedData(
    location?.search,
    IS_FROM_EPIC
  );
  const isFromAthena = EncryptUtils.getDecryptedData(
    location?.search,
    IS_FROM_ATHENA
  );
  let visitDetails;
  const baseDataGridRow = EncryptUtils.getDecryptedData(
    location?.search,
    BASE_DATA_GRID_ROW
  );
  if (baseDataGridRow) {
    visitDetails = JSON.parse(baseDataGridRow);
  }
  const mode = EncryptUtils.getDecryptedData(location?.search, MODE);
  const menuItem = new URLSearchParams(location?.search).get(BASE_MENU_ITEM);

  const aiSearchModules = globalSearchConfig?.aiSearchModules ?? [];
  const ModuleUrl = window.location.href.split('/')[4]; // Expected to be 'module'
  const submoduleUrl = window.location.href.split('/')[6]; // Expected to be 'submodule'

  let moduleglobalSearch = false;
  let submoduleglobalSearch = false;
  if (ModuleUrl === 'module' && submoduleUrl !== 'submodule') {
    const data = aiSearchModules.filter(
      (data: any) =>
        data.location === ModuleUrl && data.module_name === params.module_name
    );
    if (data.length > 0) {
      moduleglobalSearch = true;
    }
  }
  if (ModuleUrl === 'module' && submoduleUrl === 'submodule') {
    const data = aiSearchModules.filter(
      (data: any) =>
        data.location === submoduleUrl &&
        data.module_name === params.module_name
    );
    if (data.length > 0) {
      submoduleglobalSearch = true;
    }
  }
  const globalSearch = moduleglobalSearch || submoduleglobalSearch;
  // const globalSearch = banner_details?.banner?.global_search ?? false;

  const onChange = (to: string, tab: string) => {
    const paramsKey = EncryptUtils.setEncryptedParams({
      [BASE_RECORD_ID]: record_id || recordId,
      [BASE_LEGACY_APP]: legacyApp || legacy_app,
      [BASE_UNIQUE_ID]: uniqueId,
      [IS_FROM_EPIC]: isFromEpic,
      [IS_FROM_ATHENA]: isFromAthena,
      [MODE]: mode,
      [MOVE_TO_TAB]: tab
    });

    let url = `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/${module}/${BASE_ROUTE_SUB_MODULE}/${to}?${PARAMS_KEY}=${paramsKey}`;

    if (menuItem) {
      url += `&${BASE_MENU_ITEM}=${menuItem}`;
    }
    navigate(url);
  };
  const handlenavigateToPA = () => {
    const paramsKey = EncryptUtils.setEncryptedParams({
      [BASE_DEMOGRAPHIC_ID]: params?.row?.DemographicID,
      [BASE_PROCEDURE_ID]: params?.row?.ProcedureID,
      [BASE_RECORD_ID]: recordId,
      [BASE_LEGACY_APP]: props?.legacyApp || legacyApp,
      [BASE_UNIQUE_ID]: uniqueId,
      [IS_FROM_EPIC]: isFromEpic,
      [IS_FROM_ATHENA]: isFromAthena,
      [MODE]: mode,
      [INVOICE_NUMBER]: params?.row?.InvoiceNumber,
      [CHILD_TAB_NAME]: 'Encounters'
    });
    let url = `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/patient-accounting/${BASE_ROUTE_SUB_MODULE}/accounts?${PARAMS_KEY}=${paramsKey}`;
    if (menuItem) {
      url += `&${BASE_MENU_ITEM}=${menuItem}`;
    }
    AuthUtils.clearSelectedCheckBoxData();
    AuthUtils.clearSelectedCheckBoxList();
    localStorage.setItem('patient_encounterData_removed', 'true');
    navigate(url);
  };
  subModule &&
    visitDetails &&
    banner_details?.banner?.additional_banner?.fields.map(
      (item: any, index: any) => {
        console.log(item, 'renders');
      }
    );

  const init = async () => {
    try {
      if (record_id && banner_details?.banner?.sql_data.sql) {
        const data = {
          sql_data: banner_details?.banner?.sql_data,
          record_id: record_id,
          legacy_app: legacyApp
        };
        const encryptRequestData = EncryptUtils.encryptedData(data);

        const result = await getPageData(applicationName, module, subModule, {
          tk: encryptRequestData
        });
        if (banner_details?.banner?.fields) {
          banner_details.banner.fields.forEach((field: any) => {
            if (field?.type && field?.data_column) {
              if (result?.data) {
                result.data.forEach((item: any) => {
                  item[field.data_column] = HelperUtils.formatData(
                    item[field.data_column],
                    field.type,
                    field.formatter
                  );
                });
              }
            }
          });
        }
        const checkisbbhvalue = localStorage.getItem('check_isbh');
        if (checkisbbhvalue !== 'the view restricted data is true') {
          if (checkisbbhvalue === 'Without_Restricted') {
            setisRestricted(false);
          } else {
            setisRestricted(true);
          }
        } else if (checkisbbhvalue === 'the view restricted data is true') {
          setisRestricted(true);
        }
        setBannerDetailsUIData(banner_details?.banner?.fields);
        setBannerDetailsData(result?.data?.[0]);
        setBannerDetails(result?.data?.[0]);
      }
    } catch (e) {
      const errMessage = getErrorMessage(e);
      enqueueSnackbar(errMessage, SnackBarConfig.getError());
    }
  };
  const handleLegacyAppChange = async (event: any, name: string) => {
    if (lmsUIData && lmsUIData?.module_sql) {
      try {
        const data: any = {
          sql_data: lmsUIData?.module_sql.sql_data,
          sort: lmsUIData?.module_sql.sql_data.order_by,
          sort_by: lmsUIData?.module_sql.sql_data.sort_by,
          data: {name: 'App_minimal'},
          operation: 'SEARCH'
        };
        const encryptRequestData = EncryptUtils.encryptedData(data);
        const result = await getLMSResultsData(applicationName, 'LMS', {
          tk: encryptRequestData
        });
        setDropDownData(result.data);
        if (result.data.length > 0) {
          setHospitalData(result.data[0].external_org_id);
        }
        // const new_options = generateOptionsList(
        //   [{generate_options: true}],
        //   result?.data
        // );
        // await setDropDownData((prevData: any[]) => {
        //   const existingEntry = prevData?.find(
        //     (entry: {Name: string}) => entry.Name === name
        //   );

        //   if (existingEntry) {
        //     // If the Name already exists, update its Values
        //     return [...prevData];
        //   }

        //   // If the Name is new, add it to the array
        //   return [...prevData, {Name: name, Values: new_options}];
        // });
        // return new_options;
      } catch (e) {
        const errMessage = getErrorMessage(e);
        enqueueSnackbar(errMessage, SnackBarConfig.getError());
      }
    } else {
      const res = await getSearchForm(applicationName, 'FetchHospitalId');
      setLMSUIData(res?.searchForm);
      try {
        const data: any = {
          sql_data: res?.searchForm?.module_sql.sql_data,
          sort: res?.searchForm?.module_sql.sql_data.order_by,
          sort_by: res?.searchForm?.module_sql.sql_data.sort_by,
          data: {name: 'App_minimal'},
          operation: 'SEARCH'
        };
        const encryptRequestData = EncryptUtils.encryptedData(data);
        const result = await getLMSResultsData(applicationName, 'LMS', {
          tk: encryptRequestData
        });
        setDropDownData(result.data);
        if (result.data.length > 0) {
          setHospitalData(result.data[0].external_org_id);
        }
        // const new_options = generateOptionsList(
        //   [{generate_options: true}],
        //   result?.data
        // );
        // await setDropDownData((prevData: any[]) => {
        //   const existingEntry = prevData?.find(
        //     (entry: {Name: string}) => entry.Name === name
        //   );

        //   if (existingEntry) {
        //     // If the Name already exists, update its Values
        //     return [...prevData];
        //   }

        //   // If the Name is new, add it to the array
        //   return [...prevData, {Name: name, Values: new_options}];
        // });
        // return new_options;
      } catch (e) {
        const errMessage = getErrorMessage(e);
        enqueueSnackbar(errMessage, SnackBarConfig.getError());
      }
    }
  };
  React.useEffect(() => {
    init();
    if (
      environment.IS_LMS_ENABLED_FOR_EXTERNAL_SITE_AS_EMBEDDED &&
      applicationName === 'LMS'
    ) {
      handleLegacyAppChange(null, 'AllowReattemptsUntil');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [banner_details, navData]);

  const initFilterData = () => {
    if (getLocaleStorageData) {
      let filtersDataCount = 0;
      const filterData = JSON.parse(getLocaleStorageData);
      if (filterData) {
        const checkedRowIds = filterData?.map((row: any) => {
          return row?.ID;
        });
        if (checkedRowIds && checkedRowIds.length)
          filtersDataCount = checkedRowIds.length;
        if (checkedRowIds.length === 0) {
          filtersDataCount = 0;
        }
      }
      setFiltersData(filtersDataCount);
    }
  };

  const navigateMarketPlace = () => {
    navigate(
      `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/${FormConstants.MODULE.MARKETPLACE}`
    );
  };

  React.useEffect(() => {
    initFilterData();
  }, [SelectedCheckBoxState]);

  const addPad = (): void => {
    if (typeof handleAddPadAction === 'function') {
      handleAddPadAction();
    }
  };

  const editPad = (): void => {
    navigate(
      `/${BASE_ROUTE}/${BASE_APPLICATION}/${applicationId}/${BASE_ROUTE_PAD}/${padId}/${BASE_ROUTE_WIDGETS}`
    );
  };

  const savePad = (): void => {
    navigate(
      `/${BASE_ROUTE}/${BASE_APPLICATION}/${applicationId}/${BASE_ROUTE_PAD}/${padId}`
    );
  };

  const permissions = AuthUtils.getPermissions();
  const marketplacePermission =
    Array.isArray(permissions) &&
    permissions?.some(
      (ele: any) => ele.object === 'marketplace' && ele.function === 'view'
    );

  const helpIconPermission =
    Array.isArray(permissions) &&
    permissions?.some(
      (ele: any) =>
        ele.object === 'settings' && ele.function === 'view-help-icon'
    );

  const handleClickItem = async (url: string) => {
    popoverhelp.onClose();
    onHelpOptionClick(url);
  };

  const renderContent = (
    <>
      {lgUp && isNavHorizontal && <Logo sx={{mr: 2.5}} />}

      {!lgUp && (
        <IconButton onClick={onOpenNav}>
          <SvgColor src="/assets/icons/navbar/ic_menu_item.svg" />
        </IconButton>
      )}

      {globalSearch && renderParentLegacyAppFilter && renderParentLegacyAppFilter()}

      <Box sx={{py:0.5,m :0.5}}></Box>
      {globalSearch && (
        <Searchbar
          module_name={module || params.module_name}
          sub_module={subModule}
          record_id={record_id}
          ParentLegacyValue={ParentLegacyValue}
        />
      )}

      <Stack
        flexGrow={1}
        direction="row"
        alignItems="center"
        justifyContent="flex-end"
        spacing={{xs: 0.5, sm: 0.5}}>
        {/* <LanguagePopover /> */}

        {/* <NotificationsPopover /> */}

        {/* <ContactsPopover /> */}
        {module === FormConstants.MODULE.CLINICAL && subModule && (
          <Box display="flex" alignItems="center" sx={{marginTop: '6px'}}>
            <Typography variant="body1">
              {t('PRIVATE.IS_BH.VIEW_RESTRICTED_DATA', {ns: 'private'})}:
            </Typography>
            {localStorage.getItem('check_isbh') ===
            'the view restricted data is false' ? (
              <Typography
                variant="body1"
                style={{
                  marginRight: '8px',
                  marginLeft: '4px'
                }}>
                {` N.A.`}
              </Typography>
            ) : (
              <Typography
                variant="body1"
                style={{
                  color: isRestricted ? 'green' : 'red',
                  marginRight: '8px'
                }}>
                {isRestricted ? 'On' : 'Off'}
              </Typography>
            )}
          </Box>
        )}
        {subModule &&
          bannerDetailsUIData.length > 0 &&
          module === FormConstants.MODULE.CLINICAL &&
          getAdditionalLocaleStorageData &&
          JSON.parse(getAdditionalLocaleStorageData)?.length > 0 && (
            <InfoGrid item>
              <PAEncounterContainerDiv>
                <EncounterDiv>
                  {module === FormConstants.MODULE.CLINICAL && (
                    <Button onClick={handlenavigateToPA}>
                      Back to Patient Accounting
                    </Button>
                  )}
                </EncounterDiv>
              </PAEncounterContainerDiv>
            </InfoGrid>
          )}
        {subModule &&
          bannerDetailsUIData.length > 0 &&
          getLocaleStorageData &&
          JSON.parse(getLocaleStorageData)?.length > 0 && (
            <InfoGrid item>
              <EncounterContainerDiv>
                <EncounterDiv>
                  <span>
                    {' '}
                    {module === FormConstants.MODULE.CLINICAL
                      ? t('PRIVATE.DASHBOARD.FILTERS.ENCOUNTERS', {
                          ns: 'private'
                        })
                      : module === FormConstants.MODULE.PATIENT_ACCOUNTING
                        ? t('PRIVATE.DASHBOARD.FILTERS.ACCOUNTS', {
                            ns: 'private'
                          })
                        : ''}
                  </span>

                  <FilterDataDiv>{filtersData}</FilterDataDiv>
                </EncounterDiv>
              </EncounterContainerDiv>
            </InfoGrid>
          )}
        {subModule !== FormConstants.SUB_MODULE.DEMOGRAPHICS &&
          visitDetails &&
          banner_details?.banner?.additional_banner?.fields.map(
            (item: any, index: any) => {
              return (
                <InfoGrid
                  key={index}
                  item
                  sx={{
                    cursor: item?.shouldNavigate ? 'pointer' : 'default'
                  }}
                  onClick={() => {
                    if (item?.shouldNavigate && item?.navigationTo)
                      onChange(
                        item.navigationTo?.submodule,
                        item.navigationTo?.tab
                      );
                  }}>
                  <EncounterContainerDiv>
                    <EncounterDiv>
                      <span>{item.label}</span>

                      <FilterDataDiv>
                        {visitDetails[item.data_column]}
                      </FilterDataDiv>
                    </EncounterDiv>
                  </EncounterContainerDiv>
                </InfoGrid>
              );
            }
          )}
        {subModule && bannerDetailsUIData && bannerDetailsUIData.length > 0 && (
          <IconButton
            component={m.button}
            whileTap="tap"
            whileHover="hover"
            variants={varHover(1.05)}
            onClick={popover.onOpen}
            sx={{
              height: 32,
              px: 1,
              mt: 0.5,
              border: '1px solid',
              borderColor:
                theme.palette.mode === 'light'
                  ? theme.palette.primary.main
                  : theme.palette.primary.light,
              borderRadius: 10,
              background: theme => alpha(theme.palette.grey[500], 0.08),
              ...(popover.open && {
                background: theme =>
                  `linear-gradient(135deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.main} 100%)`
              })
            }}>
            {bannerDetailsUIData?.map((item: any, index: number) => {
              // if (!navData && item?.hide_banner_item) return;
              return (
                <Stack key={item.order} direction="row" alignItems="center">
                  <Typography
                    variant="body2"
                    sx={{
                      color:
                        theme.palette.mode === 'light'
                          ? theme.palette.primary.lighter
                          : theme.palette.primary.light,
                      ...(popover.open && {
                        color: theme.palette.primary.contrastText
                      })
                    }}
                    noWrap>
                    {bannerDetailsData?.[item?.data_column] || 'NA'}
                  </Typography>
                  {index !== bannerDetailsUIData.length - 1 && (
                    <Typography
                      variant="body2"
                      sx={{
                        color:
                          theme.palette.mode === 'light'
                            ? theme.palette.text.secondary
                            : theme.palette.text.disabled,
                        paddingX: '4px'
                      }}
                      noWrap>
                      {' | '}
                    </Typography>
                  )}
                </Stack>
              );
            })}
          </IconButton>
        )}

        <CustomPopover
          open={popover.open}
          onClose={popover.onClose}
          sx={{width: 200, p: 0}}>
          <Box sx={{p: 2, pb: 1.5}}>
            {subModule &&
              bannerDetailsUIData?.map((item: any, index: number) => {
                if (!navData && item?.hide_banner_item) return;
                return (
                  <Box key={index}>
                    <Typography variant="subtitle2" noWrap>
                      {item.label}
                    </Typography>

                    <Typography
                      variant="body2"
                      sx={{color: 'text.secondary'}}
                      noWrap>
                      {bannerDetailsData?.[item?.data_column] || 'NA'}
                    </Typography>
                  </Box>
                );
              })}
          </Box>
          <Divider sx={{borderStyle: 'dashed'}} />
        </CustomPopover>

        {(isFromEpic || isFromAthena) &&
        mode === FormConstants.STATIC_VALUES.VIEW ? (
          <div />
        ) : (
          <>
            {props?.showEditPadButton && (
              <Grid item sx={{display: 'flex', justifyContent: 'center'}}>
                <PadButton
                  variant="outlined"
                  startIcon={<Edit />}
                  onClick={() => editPad()}>
                  Edit
                </PadButton>
              </Grid>
            )}

            {props?.showAddPadButton && (
              <Grid item sx={{display: 'flex', justifyContent: 'center'}}>
                <PadButton
                  variant="outlined"
                  startIcon={<Add />}
                  onClick={() => addPad()}>
                  Pad
                </PadButton>
              </Grid>
            )}

            {props?.showWidgetsSaveButton && (
              <Grid item sx={{display: 'flex', justifyContent: 'center'}}>
                <PadButton variant="outlined" onClick={() => savePad()}>
                  Save
                </PadButton>
              </Grid>
            )}
            {environment.IS_LMS_ENABLED_FOR_EXTERNAL_SITE_AS_EMBEDDED &&
              environment.IS_LMS_HEADER_ENABLED_FOR_EXTERNAL_SITE &&
              applicationName === 'LMS' && (
                <Box sx={{ml: 2}}>
                  <SelectInput
                    enableDefaultOption
                    name="Select Organization"
                    placeholder="select organization"
                    options={dropDownData}
                    value={hospitalId}
                    onOpenCallback={(event: any) =>
                      handleLegacyAppChange(event, 'selectorganization')
                    }
                    onChange={(event: any) => {
                      // setHospitalId(event);
                      setHospitalData(event.target.value);
                      // setState(prevState => ({
                      //   ...prevState,
                      //   formError: ''
                      // }));
                    }}
                    optionValueKey={'external_org_id'}
                    optionLabelKey={'external_org_name'}
                    fetchOptionsFromOnOpenTrigger
                    sx={{minWidth: 200}}
                    MenuProps={{
                      PaperProps: {
                        style: {
                          maxHeight: '30vh', // Set dropdown max height
                          overflowY: 'auto' // Enable scrolling
                        }
                      }
                    }}
                  />
                </Box>
              )}
            {environment.RED_EASY_BUTTON && (
              <Box sx={{ml: 2}}>
                <RedEasyButtonComponent></RedEasyButtonComponent>
              </Box>
            )}

            {!environment?.IS_LMS_ENABLED_FOR_EXTERNAL_SITE_AS_EMBEDDED &&
              marketplacePermission && (
                <Box>
                  <Tooltip
                    title={'Marketplace'}
                    placement="bottom"
                    enterDelay={100}
                    leaveDelay={50}>
                    <IconButton
                      component={m.button}
                      whileTap="tap"
                      whileHover="hover"
                      variants={varHover(1.05)}
                      aria-label="marketplace"
                      onClick={navigateMarketPlace}
                      sx={{
                        width: 40,
                        height: 40,
                        left: 4
                      }}>
                      <Iconify icon="solar:money-bag-bold" width={24} />
                    </IconButton>
                  </Tooltip>
                </Box>
              )}

            {!environment?.IS_LMS_ENABLED_FOR_EXTERNAL_SITE_AS_EMBEDDED &&
              helpIconPermission &&
              helpResourceLinks?.length > 0 && (
                <Box>
                  <Tooltip
                    title={'Help'}
                    placement="bottom"
                    enterDelay={100}
                    leaveDelay={50}>
                    <IconButton
                      component={m.button}
                      whileTap="tap"
                      whileHover="hover"
                      variants={varHover(1.05)}
                      aria-label="help"
                      onClick={popoverhelp.onOpen}
                      sx={{
                        width: 40,
                        height: 40
                      }}>
                      <Iconify icon="material-symbols:help" width={24} />
                    </IconButton>
                  </Tooltip>
                </Box>
              )}

            <CustomPopover
              open={popoverhelp.open}
              onClose={popoverhelp.onClose}
              sx={{width: 200, p: 0}}>
              <Box sx={{p: 2, pb: 1.5}}>
                <Stack sx={{p: 1}}>
                  {helpResourceLinks?.map((option: any) => (
                    <MenuItem
                      component="a"
                      key={option.label}
                      onClick={event => {
                        event.preventDefault();
                        handleClickItem(option.linkTo);
                      }}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Stack>
              </Box>
              <Divider sx={{borderStyle: 'dashed'}} />
            </CustomPopover>

            {/* <SettingsButton /> */}

            {!environment?.IS_LMS_ENABLED_FOR_EXTERNAL_SITE_AS_EMBEDDED && (
              <AccountPopover />
            )}
          </>
        )}
      </Stack>
    </>
  );

  return (
    <AppBar
      sx={{
        height: HEADER.H_MOBILE,
        zIndex: theme.zIndex.appBar + 1,
        ...bgBlur({
          color: theme.palette.background.default
        }),
        transition: theme.transitions.create(['height'], {
          duration: theme.transitions.duration.shorter
        }),
        ...(lgUp && {
          width: `calc(100% - ${NAV.W_VERTICAL + 1}px)`,
          height: HEADER.H_DESKTOP,
          ...(offsetTop && {
            height: HEADER.H_DESKTOP_OFFSET
          }),
          ...(isNavHorizontal && {
            width: 1,
            bgcolor: 'background.default',
            height: HEADER.H_DESKTOP_OFFSET,
            borderBottom: `dashed 1px ${theme.palette.divider}`
          }),
          ...(isNavMini && {
            width: `calc(100% - ${NAV.W_MINI + 1}px)`
          })
        }),
        borderBottom: theme => `dashed 1px ${theme.palette.divider}`
      }}>
      <Toolbar
        sx={{
          height: 1
          // px: {lg: 5}
        }}>
        {renderContent}
      </Toolbar>
    </AppBar>
  );
}

